/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const All = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 16 16">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.56807 10.7481C1.70721 10.5096 2.01337 10.4291 2.25189 10.5682L7.99996 13.9212L13.748 10.5682C13.9865 10.4291 14.2927 10.5096 14.4318 10.7481C14.571 10.9867 14.4904 11.2928 14.2519 11.432L8.25189 14.932C8.09621 15.0228 7.90371 15.0228 7.74802 14.932L1.74802 11.432C1.5095 11.2928 1.42893 10.9867 1.56807 10.7481Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.56807 7.74815C1.70721 7.50962 2.01337 7.42905 2.25189 7.56819L7.99996 10.9212L13.748 7.56819C13.9865 7.42905 14.2927 7.50962 14.4318 7.74815C14.571 7.98667 14.4904 8.29283 14.2519 8.43197L8.25189 11.932C8.09621 12.0228 7.90371 12.0228 7.74802 11.932L1.74802 8.43197C1.5095 8.29283 1.42893 7.98667 1.56807 7.74815Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.74806 1.06811C7.90375 0.977296 8.09625 0.977296 8.25194 1.06811L14.2519 4.56811C14.4055 4.65772 14.5 4.82217 14.5 5C14.5 5.17783 14.4055 5.34228 14.2519 5.43189L8.25194 8.93189C8.09625 9.0227 7.90375 9.0227 7.74806 8.93189L1.74806 5.43189C1.59446 5.34228 1.5 5.17783 1.5 5C1.5 4.82217 1.59446 4.65772 1.74806 4.56811L7.74806 1.06811ZM2.99232 5L8 7.92115L13.0077 5L8 2.07885L2.99232 5Z"
      />
    </BaseSvgIcon>
  )
}

export default All
